import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CardRequestDetailService } from 'src/app/main/home-cards/card-request-detail/card-request-detail.service';
import { FreelancerRequestDetailService } from 'src/app/main/home-freelancers/freelancer-request-detail/freelancer-request-detail.service';
import { InnovationRequestDetailService } from 'src/app/main/home-innovation/innovation-request-detail/innovation-request-detail.service';
import { StandardRequestDetailService } from 'src/app/main/home-standard/standard-request-detail/standard-request-detail.service';
import { CanAccessResponse } from 'src/app/models/CanAccessResponse';
import { ApiService } from '../services/api.service';

export const requestDetailGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const apiService = inject(ApiService);
    const freelancerRequestDetailService = inject(FreelancerRequestDetailService);
    const cardRequestDetailService = inject(CardRequestDetailService);
    const standardRequestDetailService = inject(StandardRequestDetailService);
    const innovationRequestDetailService = inject(InnovationRequestDetailService);
    const queryId = route.params['id'];
    const url = state.url.split('/')[1];

    if (!queryId) {
        void router.navigate(['error', '404']);
        return false;
    }

    if (url === 'freelancers') {
        const res = await apiService.get<CanAccessResponse>(`requests/can-access-request?queryId=${queryId}`);
        if (res.canAccess) {
            freelancerRequestDetailService.request = res.detailResponse;
            return true;
        }
    }

    if (url === 'cards') {
        const res = await apiService.get<CanAccessResponse>(`cards/can-access-request?queryId=${queryId}`);
        if (res.canAccess) {
            cardRequestDetailService.request = res.detailResponse;
            return true;
        }
    }

    if (url === 'standard') {
        const res = await apiService.get<CanAccessResponse>(`standard/can-access-request?queryId=${queryId}`);
        if (res.canAccess) {
            standardRequestDetailService.request = res.detailResponse;
            return true;
        }
    }

    if (url === 'innovation') {
        const res = await apiService.get<CanAccessResponse>(`innovation/can-access-request?queryId=${queryId}`);
        if (res.canAccess) {
            innovationRequestDetailService.request = res.detailResponse;
            return true;
        }
    }

    void router.navigate(['error', '403']);
    return false;
};
